import { Box, Stack, useMediaQuery, useTheme } from '@mui/material'

import { LangList, MenuList, SocialLinksList } from './components'
import { StyledLangSocialLinksContainer } from './styled'

export default function NavBar() {
  const theme = useTheme()
  const mdAndUp = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <Box component="nav">
      <MenuList />

      {!mdAndUp && (
        <StyledLangSocialLinksContainer>
          <LangList />

          <Stack gap={2}>
            <SocialLinksList />
          </Stack>
        </StyledLangSocialLinksContainer>
      )}
    </Box>
  )
}
